import { type FC } from "react";
import { useRequest } from "../../contexts/RequestProvider";
import { GenericCheckbox } from "../three-checkbox/GenericCheckbox";

export const GenderPicker: FC = () => {
  const { setCurrentEvent: setRequestDetails, currentEvent: requestDetails } =
    useRequest();

  const ALL_GENDERS = "ALL";

  const genderArray = [
    {
      name: ALL_GENDERS,
      label: "כולם",
    },
    {
      name: "MALE",
      label: "זכר",
    },
    {
      name: "FEMALE",
      label: "נקבה",
    },
  ];

  const handleGenderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequestDetails((prev) => {
      const selectedValue = event.target.name;
      return {
        ...prev,
        // null (not undefined) so edit-save actually clears required_gender
        requiredGender: selectedValue === ALL_GENDERS
          ? null
          : (selectedValue as "MALE" | "FEMALE"),
      };
    });
  };

  const displayValue = !requestDetails.requiredGender ||
    requestDetails.requiredGender === "OTHER"
    ? ALL_GENDERS
    : requestDetails.requiredGender;

  return (
    <div className="gender-participants-container">
      <GenericCheckbox
        buttons={genderArray}
        handleChange={handleGenderChange}
        value={displayValue}
        text="מגדר"
        labelClassName="more-details-label"
      />
    </div>
  );
};
